import { useLocation } from "react-router-dom";
import { MobileStickyCTA } from "./MobileStickyCTA";

/**
 * Mounts the mobile-only sticky CTA bar across the public site,
 * EXCEPT on routes where it would clash with workflow UI:
 *   - /admin/*           (admin tools have their own UI)
 *   - /booking/*         (booking funnel — payment, signature, confirm)
 *   - /sign/*            (signature capture page)
 *   - /customer-portal/* /customer-payment
 *   - /partner/*         (partner portal)
 *   - /auth, /resume-booking
 *   - /quote             (form already has dedicated CTAs)
 *
 * Mobile-only; zero impact on tablet/desktop (component is `md:hidden`).
 */
const SUPPRESSED_PREFIXES = [
  "/admin",
  "/booking/",
  "/sign/",
  "/customer-portal",
  "/customer-payment",
  "/partner",
  "/auth",
  "/resume-booking",
  "/quote",
  "/payment-success",
  "/unsubscribe",
];

export const GlobalMobileCTA = () => {
  const { pathname } = useLocation();
  if (SUPPRESSED_PREFIXES.some((p) => pathname === p || pathname.startsWith(p))) {
    return null;
  }
  return (
    <>
      <MobileStickyCTA />
      {/* Spacer so the fixed bar never covers footer content on mobile */}
      <div className="md:hidden h-16" aria-hidden="true" />
    </>
  );
};

export default GlobalMobileCTA;
